let giftModalBtn;
let giftSection;
let giftSectionOnCartPage;

const atCartPage = window.location.pathname.includes("/cart");
// check if Equal free qty offer is turned on
const isEqualQtyFreeOfferOn = "false" === "true";

// check if Equal free qty v2 offer is turned on
const isEqualQtyFreeOfferV2On = "true" === "true";
const feqV2MainProducts = "1982-unisex-woody-citrusy-perfumeblue-desert-men-woody-citrusy-perfume1982-refill-unisex-woody-citrusy-perfumeblue-desert-refill-men-woody-citrusy-perfumebohemian-tea-unisex-citrus-aromatic-perfumebohemian-tea-refill-unisex-citrus-aromatic-perfumecharming-tuberose-women-floral-perfumecrazy-in-love-women-floral-fruity-perfumecharming-tuberose-refill-women-floral-perfumecrazy-in-love-refill-women-floral-fruity-perfumegold-noir-unisex-oriental-woody-perfumegold-noir-refill-unisex-oriental-woody-perfumeimperial-vanilla-unisex-floral-oriental-perfumejour-11-unisex-leathery-floral-perfumejour-21-unisex-woody-ambery-perfumejour-3-unisex-woody-ambery-perfumejour-8-unisex-leather-perfumejour-9-unisex-woody-spicy-perfumenoor-neroli-unisex-citrus-floral-perfumenoor-neroli-refill-unisex-citrus-floral-perfumeone-of-a-kind-men-woody-aromatic-perfumeone-of-a-kind-refill-men-woody-aromatic-perfumeoriental-soul-unisex-oriental-perfumeoriental-soul-refill-unisex-oriental-perfumesayidati-women-chypre-floral-perfumesayidati-refill-women-chypre-floral-perfumesecret-love-women-floral-fruity-perfumesecret-love-refill-women-floral-fruity-perfumesignature-men-woody-spicy-perfumesignature-refill-men-woody-spicy-perfumesilky-sandalwood-unisex-woody-spicy-perfumesilky-sandalwood-refill-unisex-woody-spicy-perfumesweet-ambrette-unisex-floral-perfumesweet-ambrette-refill-unisex-floral-perfumethe-one-and-only-men-woody-fruity-perfumethe-one-and-only-refill-men-woody-fruity-perfumewhite-rose-women-floral-perfumewhite-rose-refill-women-floral-perfume";
let feqV2FreeProductsData = [];


document.addEventListener("DOMContentLoaded", () => {
  const productDataScript = document.getElementById("feqv2-products-data");
  if (productDataScript) {
    feqV2FreeProductsData = JSON.parse(productDataScript.textContent);
  }
});

async function handlefeqV2FreeProductsFormSubmit(event) {
  event.preventDefault();
  const feqV2FreeProductsForm = $(event.target);

  const name_value_array = feqV2FreeProductsForm.serializeArray();
  const items = [];

  for (const { value } of name_value_array) {
    items.push({
      id: value,
      quantity: 1,
      properties: {
        _feqv2_free_product: true
      }
    });
  }

  addMultipleItemstoCart(items);
}

async function addMultipleItemstoCart(itemsArray) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ items: itemsArray })
  }).then(() => atCartPage ? location.reload() : cartJs())
    .catch((error) => {
      console.error("Error adding item to cart:\n", error);
      alert("Something went wrong. Please try again.");
    });
}

function removefeqV2FreeProductsForm() {
  $("#feqv2-free-products-form").remove();
  if (atCartPage) {
    $("#feqv2-free-products-form-cart-page").remove();
  }
}

function createNewfeqV2FreeProductsForm(numberofSelectors) {
  // remove old form
  removefeqV2FreeProductsForm();

  const feqV2FreeProductsSelect = Array.from(Array(numberofSelectors).keys()).map(index => productsSelectElement(feqV2FreeProductsData, `feqv2_free_product[${index}]`));

  const feqV2FreeProductsForm = makeProductAdditionForm();

  feqV2FreeProductsForm
    .append($("<h6>")
      .text(window.translations.feqv2FormTitle)
      .addClass("font-weight-bold text-uppercase"));

  feqV2FreeProductsForm
    .append($("<p>")
      .text(window.translations.feqv2FormParagraph)
      .css("fontSize", "0.75rem"));

  for (const element of feqV2FreeProductsSelect) {
    feqV2FreeProductsForm.append(element);
  }

  feqV2FreeProductsForm
    .append($("<button>")
      .addClass("btn btn-black m-0 text-uppercase")
      .text(window.translations.feqv2FormSubmit)
      .attr("type", "submit"));

  feqV2FreeProductsForm.on("submit", handlefeqV2FreeProductsFormSubmit);

  const cartDrawerProductsList = $("#jscart-row");
  // add after jscart-row
  cartDrawerProductsList.after(feqV2FreeProductsForm);
  if (atCartPage) {

    $(".table-cart").after(feqV2FreeProductsForm.clone().attr("id", "feqv2-free-products-form-cart-page"));
  }
}


function productsSelectElement(productsData, name) {
  const selectElement = $('<select>')
    .addClass("custom-select custom-select-sm rounded-0 mb-2 select-arrow-none")
    .attr("name", name)
  // .attr("required", true);

  const optionElement = $('<option>').attr({
    value: "",
    disabled: true,
    selected: true
  }).text(window.translations.feqv2FormSelect);

  selectElement.append(optionElement)

  for (const product of productsData) {
    const optionElement = $('<option>').attr({
      value: product.variantId
    }).text(product.title.replace(" 2ml", ""));

    selectElement.append(optionElement)
  }

  return selectElement
}

function makeProductAdditionForm() {
  return $("<form>")
    .attr("id", "feqv2-free-products-form")
    .addClass("d-flex flex-column pb-4")
    .attr("action", "/cart/add")
    .attr("method", "post");
}

window.addEventListener("load", async () => {
  giftModalBtn = document.querySelector("#gift-btn");
  giftSection = document.querySelector("#gift-swiper-box");
  giftSectionOnCartPage =
    document.querySelector("#gift-swiper-cart-page") || null;

  if (giftModalBtn) {
    giftModalBtn.addEventListener("click", () => {
      setTimeout(() => {
        giftSection.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 700);
    });
  }

  // Handle Checkout Page Updates
  (async function () {
    const cartData = await getCartItem();
    const cartDataJSON = JSON.parse(cartData);
    handleAboveAmountGift(cartDataJSON);
    handleAboveAmountGift_2(cartDataJSON);
    handleAboveAmountGiftChoices(cartDataJSON);
    preventDirectSamplePurchase(cartDataJSON);
  })();
});

async function getCartItem() {
  return new Promise(function (resolve, reject) {
    var req = new XMLHttpRequest();
    req.open("GET", "/cart.js");
    req.onload = function () {
      if (req.status === 200) {
        resolve(req.response);
      } else {
        reject(Error(req.statusText));
      }
    };
    req.onerror = function () {
      reject(Error("Network error"));
    };
    req.send();
  });
}

async function addItemToCart(
  item,
  quantity = 1,
  method = "add",
  doReload = false,
  customProperties = {}
) {
  /* M.Gamal | Send Gift Card to Recipient */
  const sendToRecipient =
    document.querySelector("#recipient-checkbox")?.checked || false;
  let recipientEmail;
  let recipientName;
  let recipientMessage;
  let recipientSendOn;

  if (sendToRecipient) {
    // Check Email Validaty
    const recipientForm = document.querySelector("#recipient-form");
    let validRecipientForm = recipientForm.checkValidity();
    if (!validRecipientForm) {
      recipientForm.reportValidity();
      return;
    }
    // Collect Data
    recipientEmail = document.querySelector("#recipient-email")?.value?.trim();
    recipientName = document.querySelector("#recipient-name")?.value?.trim();
    recipientMessage = document
      .querySelector("#recipient-message")
      ?.value?.trim();
    recipientSendOn = document
      .querySelector("#recipient-send-on")
      ?.value?.trim();
  }

  const productVariants =
    typeof SimpleBundles !== "undefined" ? SimpleBundles.productVariants : {};

  const hasBundle = JSON.stringify(productVariants) === "{}" ? false : true;

  const variantID = $("#variant_id").val();

  const optionsNames =
    productVariants[`${variantID}`]?.variant_options.map((o) => o.optionName) ||
    [];

  let bundleItem_0;
  let bundleItem_1;
  let bundleItem_2;
  let bundleSelection;
  if (hasBundle) {
    // Validate Form
    const productForm = document.querySelector("#bundle-product-form");
    // Capture Form Data
    const formData = new FormData(productForm);
    bundleItem_0 = formData.get(`properties[${optionsNames[0]}]`);
    bundleItem_1 = formData.get(`properties[${optionsNames[1]}]`);
    bundleItem_2 = formData.get(`properties[${optionsNames[2]}]`);
    bundleSelection = formData.get(`properties[_bundle_selection]`);
  }

  if (!item) {
    item = {
      quantity: $("#qty").val(),
      id: $("#variant_id").val(),

      // If Product is Bundle add Sub-Products as proprties
      ...(hasBundle && {
        properties: {
          [optionsNames[0]]: bundleItem_0,
          [optionsNames[1]]: bundleItem_1,
          [optionsNames[2]]: bundleItem_2,
          _bundle_selection: bundleSelection,
        },
      }),

      // If Send Gift Card to Recipient add info
      ...(sendToRecipient && {
        properties: {
          __shopify_send_gift_card_to_recipient: true,
          "Recipient email": recipientEmail,
          "Recipient name": recipientName,
          Message: recipientMessage,
          "Send on": recipientSendOn,
        },
      }),
    };
  }

  if (customProperties) {
    item.properties = {
      ...item.properties,
      ...customProperties,
    };
  }

  let resp = new Promise(function (resolve, reject) {
    let url;
    let jsonData;
    url = method == "add" ? "/cart/add.js" : "/cart/change.js";

    jsonData = method == "add" ? item : { id: item, quantity };

    // Mkayal, quick fix for the offer
    // to be removed in the future when the offer is over

    if (method == "add") {
      if (product_relations[jsonData.id] && isEqualQtyFreeOfferOn) {
        jsonData = {
          items: [
            jsonData,
            {
              quantity: jsonData.quantity,
              id: product_relations[jsonData.id],
              properties: {
                _free_equal_qty: jsonData.id,
              },
            },
          ],
        };
      } else {
        jsonData = { items: [jsonData] };
      }
    }

    // quick fix end ############ REMOVE LINE 66 AND UNCOMMENT LINE 67

    var req = new XMLHttpRequest();
    req.open("POST", url);
    req.setRequestHeader("Content-type", "application/json; charset=utf-8");
    req.onload = function () {
      if (req.status === 200) {
        resolve(req.response);
      } else {
        reject(Error(req.statusText));
      }
    };
    req.onerror = function () {
      reject(Error("Network Error"));
    };
    req.send(JSON.stringify(jsonData));
  });

  resp
    .then(
      (response) => {
        atCartPage || doReload ? location.reload() : cartJs();
      },
      (reason) => {
        toastr.error(
          localizer.didnt_add_to_your_cart_try_again,
          localizer.error
        );
        console.error(reason);
      }
    )
    .then(() => {
      getCartItem().then((response) => {
        const items = JSON.parse(response);
        document.querySelector("#item_count").innerHTML = items.item_count;
        document.querySelector("#item_count_m").innerHTML = items.item_count;
        $("#panier").removeClass("d-none");
      });
    });

  return resp;
}

async function addGiftItemToCart(t) {
  $(t).find(".spinner").show();
  const groupId = randomString(4);
  let giftBoxItem = await addItemToCart({
    quantity: 1,
    id: getGiftBox().id,
    properties: { groupId: groupId },
  });
  giftBoxItem = JSON.parse(giftBoxItem);
  const bottles = getBottle().filter((x) => x.productId);
  for (let bottle of bottles) {
    item = {
      quantity: 1,
      id: bottle.variantId,
      properties: {
        groupId: groupId,
      },
    };
    const res = await addItemToCart(item);
    if (res) {
      $("#remove_" + bottle.productId).click();
    }
  }
  $(t).find(".spinner").hide();
}

async function addSetsItemToCart(t) {
  $(t).find(".spinner").show();
  const groupId = randomString(4);
  const bottles = getSets().filter((x) => x.productId);
  for (let bottle of bottles) {
    item = {
      quantity: 1,
      id: bottle.variantId,
      properties: {
        groupId: groupId,
      },
    };
    const res = await addItemToCart(item);
    if (res) {
      $("#remove_" + bottle.productId).click();
    }
  }
  $(t).find(".spinner").hide();
}

function randomString(length) {
  var result = "";
  var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

// remove item
let cart;
$(document).ready(function () {
  setCart();
});

function setCart() {
  fetch("/cart.json")
    .then((response) => response.json())
    .then((json) => {
      cart = json;
    })
    .catch((err) => console.log("Request Failed", err));
}

async function updateCartItem(qty, groupId, isUpdated = false) {
  showLoading();
  var items;
  if (groupId.length > 5) {
    items = cart.items.filter((x) => x.key === groupId);
  } else {
    items = cart.items.filter((x) => x.properties.groupId === groupId);
  }
  if (!items) {
    await setCart();
    items = cart.items.filter((x) => x.properties.groupId === groupId);
  }

  let keysToDelete = [];
  for (const item of items) {
    keysToDelete.push(item.key);
  }

  for (const key of keysToDelete) {
    index = cart.items.findIndex((x) => x.key === key);

    await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ quantity: qty, line: index + 1 }),
    })
      .then((response) => response.json())
      .then((json) => {
        cart.items = json.items;
        items = cart.items.filter((x) => x.properties.groupId === groupId);
      })
      .catch((err) => console.log("Request Failed", err));
  }

  hideLoading();
  location.reload();
}

$(document).ready(function () {
  $("#productSelect").change(function () {
    var selectedVariant = $(this).children("option:selected").val();
    $("#variant_id").val(selectedVariant);
  });
  $("main#MainContent").addClass("ready");
});

// Plus&Minus buttons function
$(document).ready(function () {
  $(".minus").click(function () {
    var $input = $(this).parent().find("#qty");
    var count = parseInt($input.val()) - 1;
    count = count < 1 ? 1 : count;
    $input.val(count);
    $input.change();
    return false;
  });
  $(".plus").click(function () {
    var $input = $(this).parent().find("#qty");
    $input.val(parseInt($input.val()) + 1);
    $input.change();
    return false;
  });
});
//
//
//              ************************** MM JS CART CODE **************************
//              ************************** MM JS CART CODE **************************
//              ************************** MM JS CART CODE **************************
//
//
//
//

async function buyNow(l) {
  const done = await addItemToCard();
}

async function addItemToCard(variantId = "UN", event) {
  // if the variant is not already given then get the variant id from the HTML document
  variantId == "UN"
    ? (variantId = document.querySelector("#variant_id").value)
    : (variantId = variantId);

  const qty = document.querySelector("#quantity").value;
  if (variantId < 0 && !event) {
    $(".select-size.form-group").addClass("error");
    if (window.innerWidth < 575 || window.innerWidth > 1400) {
      $("#variant_id").select2("open");
    }

    $("#variant_id").change(function () {
      $(".select-size.form-group").removeClass("error");
    });

    return;
  }
  event
    ? $(`button[button-data-identifier*='${variantId}']`).addClass("disabled")
    : $("#add-to-cart").addClass("disabled");

  let resp = new Promise(function (resolve, reject) {
    const url = "/cart/add.js";
    let item = {
      quantity: qty,
      id: variantId,
    };
    const json = JSON.stringify(item);

    var req = new XMLHttpRequest();
    req.open("POST", url);
    req.setRequestHeader("Content-type", "application/json; charset=utf-8");
    req.onload = function () {
      if (req.status === 200) {
        resolve(req.response);
      } else {
        reject(Error(req.statusText));
      }
    };
    req.onerror = function () {
      reject(Error("Network Error"));
    };
    req.send(json);
  });

  resp
    .then(
      (response) => {
        cartJs();
      },
      (reason) => {
        toastr.error(
          "n'a pas ajouté à votre panier. Veuillez réessayer",
          "Erreur"
        );
        console.error(reason);
      }
    )
    .then(() => {
      getCartItem().then((response) => {
        const items = JSON.parse(response)(event)
          ? $(`button[button-data-identifier*='${variantId}']`).addClass("done")
          : $("#add-to-cart").addClass("done");
      });
    });
  setTimeout(function () {
    event
      ? $(`button[button-data-identifier*='${variantId}']`).removeClass(
        "disabled"
      )
      : $("#add-to-cart").removeClass("disabled");
    event
      ? $(`button[button-data-identifier*='${variantId}']`).removeClass("done")
      : $("#add-to-cart").removeClass("done");
  }, 4000);
  document.getElementById("cart-slider").style.visibility = "visible";
}

async function updateCartItem(qty, id) {
  showLoading(true);
  id = parseInt(id, 10);
  qty = parseInt(qty, 10);
  jQuery
    .post("/cart/change.js", { quantity: qty, id: id })
    .done(function () { })
    .fail(function () {
      toastr.error("Erreur");
    })
    .always(function () {
      location.reload();
    });
}

var item_count = 0;
function cartJs() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((data) => {
      $("#jscart-row").html("");
      if (data.items.length > 0) {
        $("#jscart-row").removeClass("empty");
        data.items.forEach((p, i) => {
          addPropductToJsCart(p, i);
        });
      } else {
        $("#jscart-row").addClass("empty");
        language = document.documentElement.lang;
        language == "fr"
          ? (msg = "Votre panier est vide")
          : (msg = "Your cart is empty");
        $("#jscart-row").html(
          `<div class="col-12 my-4 my-md-5"><h5 class="text-center m-0">${msg}</h5></div>`
        );
      }

      handleAboveAmountGift(data);
      handleAboveAmountGift_2(data);
      handleAboveAmountGiftChoices(data);

      preventDirectSamplePurchase(data);

      jsCartData(data);

      openJsCart();
    });
}

function openJsCart() {
  $("#modaljscart").modal();
}

function formatPrice(price) {
  const currentCurrency = Shopify.currency.active;
  const currentLocale = Shopify.locale;
  const discountedPrice = price;
  const displayedPrice = new Intl.NumberFormat(currentLocale, {
    style: "currency",
    currency: currentCurrency,
  }).format(discountedPrice);
  return displayedPrice;
}

function jsCartData(data) {
  const totalPrice = formatPrice(data.total_price / 100);
  $("#estimated-total > span").html(totalPrice);
  $("#item-count > span").html(data.item_count);
  item_count = data.item_count; // mkayal -- getting the item_count available in the cart
}

function addPropductToJsCart(product, i) {
  const isMainProduct = Object.keys(product_relations).includes(
    String(product.id)
  );
  const isFreeProduct = Object.values(product_relations).includes(
    String(product.id)
  );
  let isAboveAmountProduct;
  const productProperties = Object.keys(product.properties);
  for (const property of productProperties) {
    if (
      [
        "_above_amount_gift",
        "_above_amount_gift_2",
        "_above_amount_gift_choices",
      ].includes(property)
    ) {
      isAboveAmountProduct = true;
    }
  }

  const displayedPrice = formatPrice(product.discounted_price / 100);

  const cartOrder = isMainProduct ? " order-1" : " order-2";
  let variantTitle = false;
  product.product_title = product.product_title.replace(/15ml/g, "");
  if (variantTitle) {
    variantTitle = `<h5>${product.variant_title}</h5>`;
  }

  const isGiftCard = product.gift_card;

  const productTitle = product.title.toLowerCase();

  let productSubTitle = "";

  if (isGiftCard) {
    productSubTitle = Shopify.locale === "fr" ? "Carte cadeau" : "Gift Card";
  } else if (productTitle === "summer totebag") {
    productSubTitle = "Bag, 38cm x 42cm";
  } else if (productTitle === "toiletry bag majouri") {
    productSubTitle = "Bag 25,5 x 15cm";
  } else if (product.handle === "majouri-orange-fan") {
    productSubTitle = `${Shopify.locale === "fr"? "Tissu":"Fabric"}, 43x23cm`;
  } else {
    let productVolume = "75ml";

    if (productTitle.includes("10ml")) {
      productVolume = "10ml";
    }

    if (productTitle.includes("2ml")) {
      productVolume = "2ml";
    }

    if (productTitle.includes(" set")) {
      productVolume = "5 x 2ml";
    }

    if (productTitle.includes("trio")) {
      productVolume = "3 x 2ml";
    }

    productSubTitle = `Eau de Parfum, ${productVolume}`;
  }

  const productSubTitleTag = `<h5 style="font-size:9px;">${productSubTitle}</h5>`;

  let changeQtyInput = `
  <label class="text-uppercase m-0" for="updates_${product.key}">${Shopify.locale === "fr" ? "Quantité:" : "Qty:"
    }</label>
  <select
    onchange="addItemToCart('${product.key}', this.value, 'change')"
    id="updates_${product.key}"
    name="updates[]"
    class="cartjs-input"
    ${product.id == 41069090832549 ? "disabled" : ""}
  >
  ${[...Array(10).keys()].map(
      (i) =>
        `<option ${product.quantity == i + 1 ? "selected " : ""}value="${i + 1
        }">${i + 1}</option>`
    )}
  </select>`;

  if (isFreeProduct || isAboveAmountProduct) {
    changeQtyInput = `
      <span class="text-uppercase">${Shopify.locale === "fr" ? "Quantité:" : "Qty:"
      }</span>
      <span class="pl-3">${product.quantity}</span>
    `;
  }

  const productEl = `
    <div id="product-${product.key
    }" class="cart-item-container${cartOrder}" style="position:relative;">
      <div class="card mm-card card-custom-display">
        <a href="${product.url}" class="mm-card-img flex-shrink-1">
          <div class="view overlay cartjs-img align-items-start mx-auto">
            <img src="${product.featured_image.url}&width=200" alt="${product.title
    }" width="${product.featured_image.width}" height="${product.featured_image.height
    }" loading="lazy"/>
          </div>
        </a>
        <div class="mm-card-info flex-grow-1 w-50">
          <div class="d-flex flex-column h-100">
            <div class="cartjs-product-item-description">
              <div class="w-100 p-0">
                <div class="d-flex flex-column justify-content-between">
                  <a href="${product.url}">
                    <h4 class="card-title text-uppercase">${product.product_title
    }</h4>
                  </a>
                  ${productSubTitleTag}
                  ${
                    /* M. Gamal [CODE END] (1 of 2)| Create Bundle cart items*/ ""
    }
                  ${generateBundleItems(product)}
                  ${
                    /* M. Gamal [CODE END] (1 of 2)| Create Bundle cart items*/ ""
    }
                </div>
              </div>  
              <div class="d-flex flex-wrap w-100 align-items-baseline justify-content-between">
                <div class='product-counter d-flex align-items-baseline'>
                  ${changeQtyInput}
                </div>
                <div class="remove-item">
                  <button type="button" class="p-0" onclick="removeItemFromCart('${product.key
    }')">
                    <img src="//majouri.com/cdn/shop/t/133/assets/trash-can_pico.svg?v=6824503698730191291753127277" alt="Delete" width="16" height="16">
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <h4 class="p-0 flex-fill text-right w-25 price-box">${displayedPrice}</h4>
      </div>
    </div>
  `;
  $("#jscart-row").append(productEl);
}

async function removeMultipleFromCart(variantIdsOrKeysArray) {
  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      updates: variantIdsOrKeysArray.reduce((acc, id) => {
        acc[id] = 0;
        return acc;
      }, {}),
    }),
  })
    .then(() => {
      atCartPage ? location.reload() : cartJs();
    })
    .catch((error) => {
      console.error("Error removing item from cart:\n", error);
      alert("Something went wrong. Please try again.");
    });
}

function removeItemFromCart(id) {
  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      updates: {
        [id]: 0,
      },
    }),
  })
    .then(() => {
      $(`#product-${id}`).remove();
      atCartPage ? location.reload() : cartJs();
    })
    .then(() => {
      getCartItem().then((response) => {
        const items = JSON.parse(response);
        document.querySelector("#item_count").innerHTML = items.item_count;
        document.querySelector("#item_count_m").innerHTML = items.item_count;
        $("#panier").removeClass("d-none");
      });
    })
    .catch((error) => {
      console.error("Error removing item from cart:\n", error);
    });
}

/* M. Gamal [CODE START] (2 of 2)| Create Bundle cart items */
function generateBundleItems({ properties: productProprties, quantity: qty }) {
  if (!productProprties["_bundle_selection"]) {
    return "";
  }
  var items = {};
  // Getting Product Names
  subProducts = productProprties["_bundle_selection"].split(" <> ");
  // Linking Products to Their Quantities
  subProducts.forEach((i) => {
    items[i] ? items[i]++ : (items[i] = 1);
  });
  // Formatting Output
  var output = "";
  Object.keys(items).forEach((k) => {
    var itemDiv = `
      <div class="d-flex align-items-baseline justify-content-between">
        <h5 class="text-uppercase flex-grow-1 w-100" style="font-weight: 600">${k
        .replace("2ml", "")
        .replace("75ml", "")
        .trim()}</h5>
        <h5 class="d-flex align-items-baseline justify-content-end" style="font-weight: 600; gap: 0.125rem;">
          ${Shopify.locale === "fr" ? "QTE" : "QTY"}:
          <span class="text-center" style="width: 0.375rem;">
            ${items[k] * qty}
          </span>
        </h5>
      </div>  
    `;
    output += itemDiv;
  });

  if (!output) {
    return "";
  }

  return `<details class="bundle-details w-100"><summary>${Shopify.locale === "fr" ? "détails" : "details"
    }</summary><div class="w-100">${output}</div></details>`;
}
/* M. Gamal [CODE END] (2 of 2)| Create Bundle cart items */

async function preventDirectSamplePurchase(data) {
  const { items, item_count } = data;

  if (!item_count) {
    removefeqV2FreeProductsForm();
    return;
  } // If cart is empty abort

  /**
   * CHANGE LOGIC TO REMOVE SAMPLES WITH DISCOUNT ARRAY OF LENGTH ZERO
   * OR PRICE NOT EQUAL ZERO
   */

  // Getting Offer Samples IDs
  const mainProductsIDs = Object.keys(product_relations);
  const freeProductsIDs = Object.values(product_relations);

  const mainProductsQty = {};
  const freeProductsQty = {};

  const updates = {};

  // Check if product is selected in theme settings
  const is_free_sample_live = "false" === "true";
  const isabove_amount_product_live =
    "true" === "true";
  const isabove_amount_product_live_2 =
    "false" === "true";
  const isabove_amount_product_choices_live =
    "false" === "true";
  const free_sample_product = "";
  let extrafreeVariantID = null;
  // Check if above amount is selected in theme settings

  if (free_sample_product) {
    try {
      const free_sample_productResponse = await fetch(
        `/products/${free_sample_product}.js`
      );
      const free_sample_productJSON = await free_sample_productResponse.json();
      const free_sample_productVariants = free_sample_productJSON.variants;
      extrafreeVariantID = String(free_sample_productVariants[0].id) || null;
    } catch (error) {
      console.log(error);
    }
  }

  // reset free equal qty counter
  let allowedfeqV2FreeProducts = 0;
  let currentfeqV2FreeProducts = 0;
  const feqV2ProductsKeys = [];

  for (const item of items) {
    const {
      properties: {
        _free_equal_qty,
        _feqv2_free_product,
        _above_amount_gift,
        _above_amount_gift_2,
        _above_amount_gift_choices,
      },
    } = item;


    // count allowed free equal qty v2 products
    if (isEqualQtyFreeOfferV2On && feqV2MainProducts.includes(item.handle)) {
      allowedfeqV2FreeProducts += item.quantity;
    }

    // count actual free equal qty v2 products
    if (isEqualQtyFreeOfferV2On && _feqv2_free_product) {
      currentfeqV2FreeProducts += item.quantity;
      feqV2ProductsKeys.push(item.key);
    }

    // [Guard] If free sample is selected and product is not selected in theme settings
    if (_free_equal_qty && !isEqualQtyFreeOfferOn) {
      removeItemFromCart(item.key);
      return;
    }

    // [Guard] If above amount gift is selected and product is not selected in theme settings
    if (_above_amount_gift && !isabove_amount_product_live) {
      removeItemFromCart(item.key);
      return;
    }

    // [Guard] If above amount gift-2 is selected and product is not selected in theme settings
    if (_above_amount_gift_2 && !isabove_amount_product_live_2) {
      removeItemFromCart(item.key);
      return;
    }

    // [Guard] If free sample is selected and product is not selected in theme settings
    if (_above_amount_gift_choices && !isabove_amount_product_choices_live) {
      removeItemFromCart(item.key);
      return;
    }

    const variant_id = String(item.variant_id);
    const isMainProduct = mainProductsIDs.includes(variant_id);
    const isFreeProduct = freeProductsIDs.includes(variant_id);
    if (isMainProduct) {
      if (Object.keys(mainProductsQty).includes(variant_id)) {
        mainProductsQty[variant_id] += item.quantity;
      } else {
        mainProductsQty[variant_id] = item.quantity;
      }
    }
    if (
      isFreeProduct &&
      !_above_amount_gift &&
      !_above_amount_gift_2 &&
      !_above_amount_gift_choices &&
      !_feqv2_free_product
    ) {
      if (Object.keys(freeProductsQty).includes(variant_id)) {
        freeProductsQty[variant_id].quantity += item.quantity;
      } else {
        freeProductsQty[variant_id] = {
          quantity: item.quantity,
          key: item.key,
        };
      }
    }
  }

  // Reverse product_relations Object to use free products ids as keys
  const reverse_product_relations = Object.fromEntries(
    Object.entries(product_relations).map(([key, value]) => [value, key])
  );

  // Count quantity for each Main Product and each Free Product
  const freeProductQtyKeys = Object.keys(freeProductsQty);
  for (const fpKey of freeProductQtyKeys) {
    const freeProductQty = freeProductsQty[fpKey].quantity;
    const mainProductQty =
      mainProductsQty[reverse_product_relations[fpKey]] || 0;

    let extraQty = 0;
    if (
      is_free_sample_live &&
      extrafreeVariantID &&
      extrafreeVariantID === fpKey
    ) {
      extraQty += 1;
    }

    const notEqualQuantity = freeProductQty !== mainProductQty + extraQty;
    if (notEqualQuantity) {
      updates[freeProductsQty[fpKey].key] = mainProductQty + extraQty;
    }
  }

  if (
    is_free_sample_live &&
    extrafreeVariantID &&
    !freeProductQtyKeys.includes(extrafreeVariantID)
  ) {
    addItemToCart({ id: extrafreeVariantID, quantity: 1 });
  }

  if (item_count === 1 && freeProductQtyKeys.includes(extrafreeVariantID)) {
    removeItemFromCart(extrafreeVariantID);
    return;
  } // If cart is empty abort

  // Handle Free Equal Quantity V2 Offer

  if (isEqualQtyFreeOfferV2On) {
    if (allowedfeqV2FreeProducts > currentfeqV2FreeProducts) {
      const numberofSelectors = allowedfeqV2FreeProducts - currentfeqV2FreeProducts;
      createNewfeqV2FreeProductsForm(numberofSelectors);
    } else if (allowedfeqV2FreeProducts < currentfeqV2FreeProducts) {
      removeMultipleFromCart(feqV2ProductsKeys);
    }
    else {
      removefeqV2FreeProductsForm();
    }
  }


  // Handling Extra Free Product Offer

  // Re-adjust Free Products Qty if not equivalent to Main product Qty
  const updatesPKeys = Object.keys(updates);
  if (updatesPKeys.length) {
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates }),
    })
      .then(() => {
        for (const k of updatesPKeys) {
          $(`#product-${k}`).remove();
        }
        atCartPage ? location.reload() : cartJs();
      })
      .then(() => {
        getCartItem().then((response) => {
          const items = JSON.parse(response);
          document.querySelector("#item_count").innerHTML = items.item_count;
          document.querySelector("#item_count_m").innerHTML = items.item_count;
          $("#panier").removeClass("d-none");
        });
      })
      .catch((error) => {
        console.error("Error removing item from cart:\n", error);
      });
  }
}

/* M. Gamal [CODE START] (1 of 1)| Add Product if Above Amount */
async function handleAboveAmountGift(data) {
  const { original_total_price, items } = data;
  const currPriceInEuro = original_total_price / 100;
  const is_above_amount_gift_live =
    "true" === "true";
  const above_amount_product = "majouri-orange-fan";
  const aboveAmountLimit = Number.parseInt("20");

  if (
    !is_above_amount_gift_live ||
    !above_amount_product ||
    !aboveAmountLimit
  ) {
    return;
  }

  let giftInCart = false;
  let giftItemKey = null;
  let giftQty = 1;

  for (const item of items) {
    const {
      key,
      properties: { _above_amount_gift = null },
      quantity,
    } = item;

    if (_above_amount_gift) {
      giftInCart = true;
      giftItemKey = key;
      giftQty = quantity;
    }
  }

  // Is the Total above or equal the limit
  const isTotalAboveAmount = currPriceInEuro >= aboveAmountLimit;

  // Get Above Amount Variant ID
  let AboveAmountGiftVariantID = null;
  if (above_amount_product) {
    try {
      const above_amount_productResponse = await fetch(
        `/products/${above_amount_product}.js`
      );
      const above_amount_productJSON =
        await above_amount_productResponse.json();
      if (!above_amount_productJSON.available) {
        console.log("Gift Product is not Available!");
        return;
      }
      const above_amount_productVariants = above_amount_productJSON.variants;
      AboveAmountGiftVariantID =
        String(above_amount_productVariants[0].id) || null;
    } catch (error) {
      console.log(error);
      return;
    }
  }

  if (!AboveAmountGiftVariantID) {
    return;
  }

  if (giftInCart && giftQty > 1) {
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates: { [giftItemKey]: 1 } }),
    })
      .then(() => {
        atCartPage && location.reload();
      })
      .then(() => {
        getCartItem().then((response) => {
          const items = JSON.parse(response);
          document.querySelector("#item_count").innerHTML = items.item_count;
          document.querySelector("#item_count_m").innerHTML = items.item_count;
          $("#panier").removeClass("d-none");
        });
      })
      .catch((error) => {
        console.error("Error removing item from cart:\n", error);
      });
  }

  if (isTotalAboveAmount && giftInCart) {
    return;
  }

  if (isTotalAboveAmount && !giftInCart) {
    addItemToCart(
      { id: AboveAmountGiftVariantID, quantity: 1 },
      1,
      "add",
      false,
      {
        Discount: `Above ${aboveAmountLimit} EUR Gift`,
        _above_amount_gift: `${AboveAmountGiftVariantID}`,
      }
    );
  }

  if (!isTotalAboveAmount && giftInCart) {
    removeItemFromCart(giftItemKey);
  }
}

async function handleAboveAmountGift_2(data) {
  const { original_total_price, items } = data;
  const currPriceInEuro = original_total_price / 100;
  const is_above_amount_gift_live =
    "false" === "true";
  const above_amount_product = "";
  const aboveAmountLimit = Number.parseInt(
    "75"
  );

  if (
    !is_above_amount_gift_live ||
    !above_amount_product ||
    !aboveAmountLimit
  ) {
    return;
  }

  let giftInCart = false;
  let giftItemKey = null;
  let giftQty = 1;

  for (const item of items) {
    const {
      key,
      properties: { _above_amount_gift_2 = null },
      quantity,
    } = item;

    if (_above_amount_gift_2) {
      giftInCart = true;
      giftItemKey = key;
      giftQty = quantity;
    }
  }

  // Is the Total above or equal the limit
  const isTotalAboveAmount = currPriceInEuro >= aboveAmountLimit;

  // Get Above Amount Variant ID
  let AboveAmountGiftVariantID = null;
  if (above_amount_product) {
    try {
      const above_amount_productResponse = await fetch(
        `/products/${above_amount_product}.js`
      );
      const above_amount_productJSON =
        await above_amount_productResponse.json();
      if (!above_amount_productJSON.available) {
        console.log("Gift Product is not Available!");
        return;
      }
      const above_amount_productVariants = above_amount_productJSON.variants;
      AboveAmountGiftVariantID =
        String(above_amount_productVariants[0].id) || null;
    } catch (error) {
      console.log(error);
      return;
    }
  }

  if (!AboveAmountGiftVariantID) {
    return;
  }

  if (giftInCart && giftQty > 1) {
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates: { [giftItemKey]: 1 } }),
    })
      .then(() => {
        atCartPage && location.reload();
      })
      .then(() => {
        getCartItem().then((response) => {
          const items = JSON.parse(response);
          document.querySelector("#item_count").innerHTML = items.item_count;
          document.querySelector("#item_count_m").innerHTML = items.item_count;
          $("#panier").removeClass("d-none");
        });
      })
      .catch((error) => {
        console.error("Error removing item from cart:\n", error);
      });
  }

  if (isTotalAboveAmount && giftInCart) {
    return;
  }

  if (isTotalAboveAmount && !giftInCart) {
    addItemToCart(
      { id: AboveAmountGiftVariantID, quantity: 1 },
      1,
      "add",
      false,
      {
        Discount: `Above ${aboveAmountLimit} EUR Gift`,
        _above_amount_gift_2: `${AboveAmountGiftVariantID}`,
      }
    );
  }

  if (!isTotalAboveAmount && giftInCart) {
    removeItemFromCart(giftItemKey);
  }
}

async function handleAboveAmountGiftChoices(data) {
  const { original_total_price, items } = data;
  const currPriceInEuro = original_total_price / 100;
  const is_above_amount_gift_live =
    "false" === "true";
  const above_amount_products = "";
  const aboveAmountLimit = Number.parseInt(
    "500"
  );

  if (
    !is_above_amount_gift_live ||
    !above_amount_products ||
    !aboveAmountLimit
  ) {
    hideGift();
    return;
  }

  let giftInCart = false;
  let giftItemKey = null;
  let giftQty = 1;

  for (const item of items) {
    const {
      key,
      properties: { _above_amount_gift_choices = null },
      quantity,
    } = item;

    if (_above_amount_gift_choices) {
      giftInCart = true;
      giftItemKey = key;
      giftQty = quantity;
    }
  }

  // Is the Total above or equal the limit
  const isTotalAboveAmount = currPriceInEuro >= aboveAmountLimit;

  // Show Gift Button

  if (giftInCart && giftQty > 1) {
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates: { [giftItemKey]: 1 } }),
    })
      .then(() => {
        atCartPage && location.reload();
      })
      .then(() => {
        getCartItem().then((response) => {
          const items = JSON.parse(response);
          document.querySelector("#item_count").innerHTML = items.item_count;
          document.querySelector("#item_count_m").innerHTML = items.item_count;
          $("#panier").removeClass("d-none");
        });
      })
      .catch((error) => {
        console.error("Error removing item from cart:\n", error);
      });
  }

  if (isTotalAboveAmount && giftInCart) {
    hideGift();
    return;
  }

  if (!isTotalAboveAmount && giftInCart) {
    hideGift();
    removeItemFromCart(giftItemKey);
  }

  if (isTotalAboveAmount && !giftInCart) {
    showGift();
  }

  if (!isTotalAboveAmount && !giftInCart) {
    hideGift();
  }
}
/* M. Gamal [CODE END] (1 of 1)| Add Product if Above Amount */

/* Gift Choices */
function hideGift() {
  if (giftModalBtn) {
    giftModalBtn.classList.add("d-none");
  }
  if (giftSection) {
    giftSection.classList.add("d-none");
  }
  if (giftSectionOnCartPage) {
    giftSectionOnCartPage.classList.add("d-none");
  }
}

function showGift() {
  if (giftModalBtn) {
    giftModalBtn.classList.remove("d-none");
  }
  if (giftSection) {
    giftSection.classList.remove("d-none");
  }
  if (giftSectionOnCartPage) {
    giftSectionOnCartPage.classList.remove("d-none");
  }
}
/* Gift Choices */
